import { Route } from '@angular/router';
import { MsalGuard } from './auth/msal.config';
import { RedirectComponent } from './auth/redirect.component';

export const appRoutes: Route[] = [
  { path: 'redirect', component: RedirectComponent },
  {
    path: 'login-failed',
    loadComponent: () =>
      import('./features/login-failed/login-failed.component').then(
        (m) => m.LoginFailedComponent
      ),
  },
  {
    // The whole app IS the player. MsalGuard enforces an Entra sign-in; the
    // read API is independently gated server-side (a Software Security
    // ViewFeature, fail-closed), so an entitled viewer sees their sessions and
    // an unentitled one gets the API's 403 surfaced inside the player rather
    // than any session data. That server-side gate is the security boundary,
    // which is why there is no client SecurityGuard here (v1).
    //
    path: '',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('@ups/xplat/web/ryn-replay/routing').then(
        (m) => m.RynReplayPlayerRoutingModule
      ),
  },
  // ADO / embedded-host deep links use /replay/{sessionId} (Software Security
  // shape). This standalone app normally uses /{sessionId}; alias the prefix so
  // pasted links open the player instead of treating "replay" as the session id.
  {
    path: 'replay',
    canActivate: [MsalGuard],
    loadChildren: () =>
      import('@ups/xplat/web/ryn-replay/routing').then(
        (m) => m.RynReplayPlayerRoutingModule
      ),
  },
];
